import React from 'react';

const Granja = () => {
  return (
    <div className="container mt-5 pt-3">
      {/* Section 1: Bootstrap Carousel */}
      <div id="granjaCarousel" className="carousel slide mb-5" data-bs-ride="carousel">
        <div className="carousel-indicators">
          <button type="button" data-bs-target="#granjaCarousel" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
          <button type="button" data-bs-target="#granjaCarousel" data-bs-slide-to="1" aria-label="Slide 2"></button>
          <button type="button" data-bs-target="#granjaCarousel" data-bs-slide-to="2" aria-label="Slide 3"></button>
          <button type="button" data-bs-target="#granjaCarousel" data-bs-slide-to="3" aria-label="Slide 4"></button>
          <button type="button" data-bs-target="#granjaCarousel" data-bs-slide-to="4" aria-label="Slide 5"></button>
          <button type="button" data-bs-target="#granjaCarousel" data-bs-slide-to="5" aria-label="Slide 6"></button>
        </div>
        
        <div className="carousel-inner rounded shadow">
          <div className="carousel-item active">
            <img src="/granja.JPG" className="d-block w-100" alt="Animales de granja" style={{ maxHeight: '600px', width: '100%', objectFit: 'contain' }} />
          </div>
          <div className="carousel-item">
            <img src="/granja2.JPG" className="d-block w-100" alt="Vacas y terneros" style={{ maxHeight: '600px', width: '100%', objectFit: 'contain' }} />
          </div>
          <div className="carousel-item">
            <img src="/granja4.jpeg" className="d-block w-100" alt="caballo 2" style={{ maxHeight: '600px', width: '100%', objectFit: 'contain' }} />
          </div>
          <div className="carousel-item">
            <img src="/sec3_granja.jpg" className="d-block w-100" alt="Ovejas y corderos" style={{ maxHeight: '600px', width: '100%', objectFit: 'contain' }} />
          </div>
          <div className="carousel-item">
            <img src="/cabalgata.jpg" className="d-block w-100" alt="caballo" style={{ maxHeight: '600px', width: '100%', objectFit: 'contain' }} />
          </div>
          <div className="carousel-item">
            <img src="/cabalgata2.jpg" className="d-block w-100" alt="caballo 2" style={{ maxHeight: '600px', width: '100%', objectFit: 'contain' }} />
          </div>
        </div>
        
        <button className="carousel-control-prev" type="button" data-bs-target="#granjaCarousel" data-bs-slide="prev">
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button className="carousel-control-next" type="button" data-bs-target="#granjaCarousel" data-bs-slide="next">
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
      
      {/* Section 2: Title and Description */}
      <div className="row">
        <div className="col-12 text-center">
          <h1 className="display-4 text-success mb-3">GRANJA</h1>
          <p className="lead mb-5">Ven e Interactúa con nuestros animalitos de la granja y conoce más de ellos.</p>
        </div>
      </div>
      
      {/* Section 3: Information and Recommendations */}
      <div className="row mb-5">
        <div className="col-md-8 mx-auto text-center">
          <h2 className="mb-4 text-success">Información importante</h2>
          
          <div className="mb-4">
            <h4>Horario:</h4>
            <p className="fs-5">De 8 am – 5 pm</p>
          </div>
          
          <h4>Recomendaciones:</h4>
          <ul className="list-group mb-4 mx-auto" style={{maxWidth: '400px'}}>
            <li className="list-group-item border-0 d-flex align-items-center justify-content-center">
              <i className="bi bi-check-circle-fill text-success me-2"></i>
              Zapatos cerrados
            </li>
            <li className="list-group-item border-0 d-flex align-items-center justify-content-center">
              <i className="bi bi-check-circle-fill text-success me-2"></i>
              Traer sombrero
            </li>
            <li className="list-group-item border-0 d-flex align-items-center justify-content-center">
              <i className="bi bi-check-circle-fill text-success me-2"></i>
              Bloqueador solar
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Granja;